import React, { useState } from 'react';
import { Box, Button, Heading, Layer, TextInput, Tip } from 'grommet';
import { Close, Send } from 'grommet-icons';
import PropTypes from 'prop-types';
import { PipelineService } from '@enrich/shared-lib';

export const PipelineManualReportButton = ({ pipeline }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Tip content="send manual report">
                <Button
                    secondary
                    label=<span>
                        <Send size="medium" color="enrich-blue" />
                    </span>
                    onClick={() => setShowModal(true)}
                />
            </Tip>
            {showModal && (
                <PipelineManualReportModal
                    pipeline={pipeline}
                    setShowModal={setShowModal}
                />
            )}
        </>
    );
};

const PipelineManualReportModal = ({ pipeline, setShowModal }) => {
    const [email, setEmail] = useState('');
    const [buttonBusy, setButtonBusy] = useState();

    const createReport = async () => {
        try {
            setButtonBusy(true);
            await new PipelineService().sendReport(pipeline.id, email);
            setShowModal(false);
        } catch (error) {
            setButtonBusy(false);
            console.log(error);
        }
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Send manual report for {pipeline.attributes.name}
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => {
                                setShowModal(false);
                            }}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <Box
                        width="medium"
                        align="center"
                        round="6px"
                        background="white">
                        <TextInput
                            dropHeight="medium"
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="Email"
                            value={email}
                        />
                    </Box>
                </Box>
                <Box>
                    <Button
                        primary
                        busy={buttonBusy}
                        disabled={!email.length}
                        label="Send email report"
                        style={{ width: '220px', height: '50px' }}
                        alignSelf="center"
                        onClick={createReport}
                    />
                </Box>
            </Box>
        </Layer>
    );
};

PipelineManualReportButton.propTypes = {
    pipeline: PropTypes.object,
};

PipelineManualReportModal.propTypes = {
    pipeline: PropTypes.object,
    setShowModal: PropTypes.func,
};
